export default function listMenu() {
  return {
    _id: false,
    type: 'droplet.listMenu',
    mediaQueries: [],
    order: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/list-menu/droplet.schema.js